module.exports = __webpack_public_path__ + "media/flags/gi-344648c0.svg";